import React from 'react';
import EducationalOnePager from './EducationalOnePager.jsx';

function App() {
  return <EducationalOnePager />;
}

export default App;